import React from 'react';
import { PercentCell } from './PercentCell';
import { section } from './rows';
import { formatMeasure } from './units';

/** Diagnostics rows: the engine block (tires are drawn separately, around the silhouette). */
export const diagnosticsSections = (view, ctx) => {
	const { t } = ctx;
	const label = (key) => t(`oemDataModal_cerebrumx_diagnostics_${key}`);
	const oilLife = view.oilLife && <PercentCell value={view.oilLife.value} label={label('oilLife')} ctx={ctx} />;

	return [
		section(
			'engine',
			[
				{ key: 'oilLife', icon: 'opacity', label: label('oilLife'), value: oilLife },
				{
					key: 'coolantTemperature',
					icon: 'thermostat',
					label: label('coolantTemperature'),
					value: formatMeasure(view.coolantTemperature, ctx),
				},
				{
					key: 'engineSpeed',
					icon: 'speed',
					label: label('engineSpeed'),
					value: formatMeasure(view.engineSpeed, ctx),
				},
				{
					key: 'ignitionStatus',
					icon: 'power_settings_new',
					label: label('ignitionStatus'),
					value: view.ignitionStatus,
				},
				{
					key: 'engineHours',
					icon: 'schedule',
					label: label('engineHours'),
					value: formatMeasure(view.engineTime, ctx),
				},
			],
			label('engine'),
		),
	];
};
